<template>
  <div>
    <div class="tw-text-gray-800">Comment</div>
    <div class="tw-mt-0.5 tw-text-xs tw-text-gray-500">
      {{ event.label }}
    </div>
    <base-button type="text" size="xs" @click="$emit('editComment', event)">Edit / Delete</base-button>
  </div>
</template>

<script>
export default {
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
};
</script>
